import { render } from "./TheContact.vue?vue&type=template&id=50751f04&scoped=true"
import script from "./TheContact.vue?vue&type=script&lang=js"
export * from "./TheContact.vue?vue&type=script&lang=js"

import "./TheContact.vue?vue&type=style&index=0&id=50751f04&scoped=true&lang=css"

import exportComponent from "/Users/fasa/JS/freelance/UgaldeYAsociados/gerardoyasociados-website-final/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50751f04"]])

export default __exports__